import { useAuth } from '../../context/AuthContext'

const useAccessControl = () => {
  const { user } = useAuth()

  const hasAccess = (rights = {}) => {
    if (!user) {
      return false
    }

    const { module: moduleName } = rights

    if (user.is_superAdmin) {
      return true
    }
    const company = user.company

    const roleAccess = user.role.access_rights.find((r) => r.module.module === moduleName)

    if (!roleAccess) {
      return false
    }

    if (company.contracts && company.contracts.length > 0) {
      const contract = company.contracts[0]

      const contractLine = contract.lines.find((line) => line.module === moduleName)

      if (contractLine && contractLine.is_access === true) {
        return true
      }

      return false
    }

    return roleAccess.module.is_free_account === true
  }

  return { hasAccess }
}

export default useAccessControl
